import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { EventModel, LeaderboardGameScore } from '@frontend/sports/betting-offer/feature/model';

@Component({
    selector: 'ms-race-info',
    templateUrl: './race-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RaceInfoComponent {
    @Input() event: EventModel;
    @HostBinding('class') className = 'laps';
    get score(): LeaderboardGameScore {
        return this.event.scoreboard.getScore<LeaderboardGameScore>()!;
    }
}
